import { Injectable, signal } from '@angular/core';
import { UserResponse } from '@app/types/user.types';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public user = signal<UserResponse | null>(null);
  public authenticated = signal<boolean>(false);

  constructor() { }

  public updateUser(user: UserResponse) {
    this.user.set(user);
  }

  public updateAuthenticated(value: boolean) {
    this.authenticated.set(value);
  }

  public clear() {
    this.user.set(null);
    this.authenticated.set(false);
  }
}
